import { render } from "./AllProjectsView.vue?vue&type=template&id=4c023097"
import script from "./AllProjectsView.vue?vue&type=script&lang=js"
export * from "./AllProjectsView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__